import { apiRequest, createUrlWithCenterId } from '../utils/apiHelpers';

export interface AgendaEvento {
  tareaId: number;
  relevamientoId?: number | null;
  nombre?: string;
  descripcion?: string;
  tipoDeTareaId: number;
  tipoDeTarea?: string;
  estadoDeTareaId: number;
  clienteId: number;
  cliente?: string;
  sucursalId: number;
  sucursal?: string;
  usuarioId: number;
  usuario?: string;
  fecha: string;
  fechaFin?: string;
  start?: string;
  end?: string;
  color?: string;
  title?: string;
  editable?: boolean;
}

export interface AgendaCombo {
  id: number;
  nombre: string;
}

export interface AgendaAsignarRequest {
  tareaId: number;
  relevamientoId?: number | null;
  start: string;
  end?: string | null;
  usuarios: number[];
}

export const agendaService = {
  async getEvents(params: {
    start: string;
    end: string;
    usuarioId?: number | null;
  }): Promise<AgendaEvento[]> {
    const endpoint = createUrlWithCenterId('/api/Agenda', {
      start: params.start,
      end: params.end,
      ...(params.usuarioId ? { usuarioId: params.usuarioId } : {}),
    });
    return apiRequest(endpoint);
  },

  async getPendientes(params?: {
    start?: string;
    end?: string;
    tipoTareaId?: number | null;
    usuarioId?: number | null;
  }): Promise<AgendaEvento[]> {
    const endpoint = createUrlWithCenterId('/api/Agenda/pendientes', {
      ...(params?.start ? { start: params.start } : {}),
      ...(params?.end ? { end: params.end } : {}),
      ...(params?.tipoTareaId ? { tipoTareaId: params.tipoTareaId } : {}),
      ...(params?.usuarioId ? { usuarioId: params.usuarioId } : {}),
    });
    return apiRequest(endpoint);
  },

  async getUsuariosParaTarea(tareaId: number): Promise<AgendaCombo[]> {
    return apiRequest(createUrlWithCenterId(`/api/Agenda/${tareaId}/usuarios`));
  },

  async asignar(body: AgendaAsignarRequest): Promise<{ valid?: boolean; message?: string }> {
    return apiRequest(createUrlWithCenterId('/api/Agenda/asignar'), {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

  async crearRelevamiento(body: {
    sucursalId: number;
    tipoDeProductoId: number;
    tipoDeElementoId?: number | null;
    periodicidadId?: number | null;
    fecha: string;
    nombre?: string;
    descripcion?: string;
  }): Promise<AgendaEvento> {
    return apiRequest(createUrlWithCenterId('/api/Agenda/relevamientos'), {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },
};
